import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import '../../styles/GlobalThemeStyleCQ';
import { Card, Button, Radio, Avatar, Collapse, Timeline } from 'antd';

export const TimelineCard = styled(Card)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.CQColors.white};
	border: 1px solid rgba(87, 99, 111, 0.1);
	border-radius: 5px;
	margin-top: 5px;
	.ant-card-body {
		padding: 0px;
		@media only screen and (max-width: 375.99px) {
			padding: 0px !important;
		}
	}
	.hasPadding {
		width: 100%;
		position: relative;
		padding: 20px;
		@media only screen and (max-width: 375.99px) {
			padding: 10px;
		}
	}
	h6.title {
		margin: 0px;
		font-weight: 500;
		font-size: 14px;
		line-height: 18px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}

	span.innerButton {
		margin-right: 10px;
		font-weight: 500;
		font-size: 12px;
		line-height: 15px;
		color: ${({ theme }) => theme.CQColors.secondaryColor};
		cursor: pointer;
		img,
		svg {
			filter: ${({ theme }) => theme.CQColors.imgFilterColor} !important;
		}
	}

	@media only screen and (max-width: 768.99px) {
	}
`;
export const TimelineEditCard = styled(Card)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.CQColors.white};
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	border-radius: 0px 0px 5px 5px;
	.ant-card-body {
		padding: 10px 20px !important;
		max-height: 100% !important;
		min-height: auto !important;
		overflow: hidden;

		&::-webkit-scrollbar,
		&::-webkit-scrollbar-thumb,
		&::-webkit-scrollbar {
			display: none;
		}
	}

	.titleText {
		font-weight: 500;
		font-size: 13px;
		line-height: 15px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}
	@media only screen and (max-width: 768.99px) {
	}
`;
export const XCollapse = styled(Collapse)`
	background: none !important;
	.ant-collapse-header {
		background: none !important;
		padding: 0px !important;
		font-weight: 500;
		font-size: 12px;
		line-height: 40px;
		color: ${({ theme }) => theme.CQColors.themeColor2};
	}
	.ant-collapse-content-box {
		padding: 0px !important;
	}
	@media only screen and (max-width: 768.99px) {
	}
`;
export const XTimeline = styled(Timeline)`
	.ant-timeline-item-tail {
		display: none;
	}
	.ant-timeline-item-head {
		display: none;
	}
	.ant-timeline-item-content {
		margin-left: 0px !important;
	}
`;
